import { DateFormat, transformDate } from 'shared/entities/date';
import { isDateBeforeMinAvailable } from 'shared/entities/date/utils/minAvailablePeriod';
import type { ValidatorResult } from 'shared/entities/validator';

import { RECONCILIATION_ACT_MIN_AVAILABLE_DATE } from '../reconciliationActConstants';

export const validateReconciliationPeriod = (
  from: Date,
  to: Date,
  minDate: Date = RECONCILIATION_ACT_MIN_AVAILABLE_DATE
): ValidatorResult => {
  if (
    isDateBeforeMinAvailable(from, minDate) ||
    isDateBeforeMinAvailable(to, minDate)
  ) {
    const formattedDate = transformDate(minDate, DateFormat.dayMonthYear);

    return (t) =>
      t('Documents.ReconciliationActModal.minAvailableDateError', {
        ns: 'settingsPage',
        date: formattedDate
      });
  }

  return null;
};
